__turbopack_context__.v({
  "category-container": "course-variations-overview-module-scss-module__VdPJha__category-container",
  "category-item": "course-variations-overview-module-scss-module__VdPJha__category-item",
  "category-item-content": "course-variations-overview-module-scss-module__VdPJha__category-item-content",
  "category-item-link": "course-variations-overview-module-scss-module__VdPJha__category-item-link",
  "category-item-selected": "course-variations-overview-module-scss-module__VdPJha__category-item-selected",
  "category-item-title": "course-variations-overview-module-scss-module__VdPJha__category-item-title",
  "category-title": "course-variations-overview-module-scss-module__VdPJha__category-title",
  "course-variations": "course-variations-overview-module-scss-module__VdPJha__course-variations",
  "course-variations-categories": "course-variations-overview-module-scss-module__VdPJha__course-variations-categories",
  "course-variations-content": "course-variations-overview-module-scss-module__VdPJha__course-variations-content",
  "course-variations-header": "course-variations-overview-module-scss-module__VdPJha__course-variations-header",
  "filler": "course-variations-overview-module-scss-module__VdPJha__filler",
  "title": "course-variations-overview-module-scss-module__VdPJha__title",
});
